import { blue } from '@bufferapp/ui/style/colors';
import styled from 'styled-components';

export const MentionText = styled.span<{ $valid: boolean }>`
  color: ${(p) => (p.$valid ? blue : 'inherit')};
`;
